import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#4C5B7F] to-[#2C3B5F] text-white antialiased font-sans scroll-smooth">
      <header className="max-w-6xl mx-auto px-6 py-8 flex items-center justify-between">
        <div className="font-bold text-lg">DeenLock</div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>

        <p className="text-white/80 mb-4">
          At DeenLock, your privacy and safety are our top priority. This policy explains what information we collect and how it is used.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
        <p className="text-white/80 mb-4">
          DeenLock collects only the following information:
          <ul className="list-disc list-inside mt-2">
            <li>Email address and username/name provided by the user</li>
            <li>Progress data such as Quran pages read, streaks, reflections, and other activity within the app</li>
          </ul>
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Your Data</h2>
        <p className="text-white/80 mb-4">
          Your data is used solely to provide app functionality and track your progress. All progress data is stored securely in our database. We do not sell, share, or use your data for advertising.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">3. Security</h2>
        <p className="text-white/80 mb-4">
          We employ industry-standard measures to protect your data. Only essential progress and account information is stored. Please also secure your device with a password, Face ID, or Touch ID.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Children & Families</h2>
        <p className="text-white/80 mb-4">
          DeenLock is designed for users of all ages. Parents and guardians are encouraged to supervise children’s usage. We do not knowingly collect sensitive personal data from children under 13. Parents remain in full control of the app usage.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">5. App Permissions</h2>
        <p className="text-white/80 mb-4">
          Certain features, like Barakah Mode (app-blocking), may request device permissions. These permissions are used <strong>only</strong> to enable the requested feature and are never used for tracking or advertising.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">6. No Third-Party Tracking</h2>
        <p className="text-white/80 mb-4">
          DeenLock does not use analytics, advertising networks, or other third-party tracking. Your usage remains private.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">7. Changes to Policy</h2>
        <p className="text-white/80 mb-4">
          We may update this Privacy Policy to reflect improvements or legal requirements. The latest version will always be available in the app and on our website.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">8. Contact Us</h2>
        <p className="text-white/80 mb-4">
          For questions about privacy or data handling, contact us at{" "}
          <a href="mailto:deenlockapp@gmail.com" className="underline hover:text-[#FFD369]">
            deenlockapp@gmail.com
          </a>.
        </p>
      </main>

      <footer className="border-t border-white/10 py-8 mt-20">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4 text-white/60">
          <div className="text-sm">© {new Date().getFullYear()} DeenLock — All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-sm hover:text-white transition">Back to Home</Link>
            <Link to="/terms-of-use" className="text-sm hover:text-white transition">Terms of Use</Link>
            <a href="mailto:deenlockapp@gmail.com" className="text-sm hover:text-white transition">deenlockapp@gmail.com</a>
          </div>
        </div>
      </footer>

      <style>{`html { scroll-behavior: smooth; }`}</style>
    </div>
  );
}
